export enum RequestTypeKind {
    Srv = 1,
    Wrh = 2,
    Smzrgs = 3
}